import { Outlet } from "react-router-dom";
import AppHeader from "../../components/app-header";
import AppFooter from "../../components/app-footer";

export default function LayoutPage() {
  return (
    <>
      <AppHeader />
      <div className="flex flex-col md:min-h-[calc(100vh-8rem)] bg-white justify-between mt-16">
        <Outlet></Outlet>
      </div>
      <AppFooter></AppFooter>
    </>
  );
}
